import { createTheme, responsiveFontSizes } from "@material-ui/core"

let theme = createTheme({
    palette: {
      primary: {
        main: "#4682B4",
        contrastText: "white" 
      },
    }
});

theme = responsiveFontSizes(theme)
export default theme